module.exports = __webpack_public_path__ + "static/media/KinjaRun.e1e2b948.png";